import request from '../../../util/SuperagentUtils';
import {
  bookingRequests,
  bookingTransactionRequests,
  buyerBookingsReportEndpoints,
  supplierBookingsReportEndpoints
} from '../../../requests/api-endpoints';

type BookingReportQueryParams = {
  accountId: string,
  locationId?: string,
  supplierName?: string,
  buyerName?:string,
  bookingNumber?: string,
  equipmentType?: string,
  frequency?: string,
  status?: string,
  page?: number,
  size?: number,
  sortDir?: string,
  sortBy?: string
};

const getBookingSearchParams = (searchParams: BookingReportQueryParams, isPageable: boolean) => {

  const { locationId, supplierName, buyerName, bookingNumber, equipmentType, frequency, status, page, size, sortDir, sortBy } = searchParams;

  const params = isPageable ? new URLSearchParams([["page", page || 0], ["size", size || 10]]) : new URLSearchParams();

  if (locationId) {
    params.append("locationId", locationId)
  }
  if (supplierName) {
    params.append("supplierName", supplierName)
  }
  if (buyerName) {
    params.append("buyerName", buyerName)
  }
  if (equipmentType && equipmentType !== "All") {
    params.append("assetTypeGroup", equipmentType)
  }
  if (status) {
    params.append("status", status)
  }
  if (frequency) {
    params.append("frequency", frequency)
  }
  if (sortBy) {
    params.append("sortBy", sortBy)
  }
  if (sortDir) {
    params.append("sortDir", sortDir)
  }
  if (bookingNumber) {
    params.append("bookingNumber", bookingNumber)
  };

  return params;
}

export const getBuyerBookings = (
  searchParams: BookingReportQueryParams,
  onSuccess,
  onFail
) => {

  const result = request.get(`${buyerBookingsReportEndpoints.search}?${getBookingSearchParams(searchParams, true).toString()}`);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
};

export const getSupplierBookings = (
  searchParams: BookingReportQueryParams,
  onSuccess,
  onFail
) => {

  const result = request.get(`${supplierBookingsReportEndpoints.search}?${getBookingSearchParams(searchParams, true).toString()}`);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
};

export const getSupplierBookingCSVDownload = (searchParams: BookingReportQueryParams) => {
  return `${supplierBookingsReportEndpoints.report}?${getBookingSearchParams(searchParams, false).toString()}`;
}

export const getAllBuyerBookings = (sortBy: String, sortDir: String) : Promise => {
    const queryParams = new URLSearchParams();
    if (sortBy) queryParams.append('sortBy', sortBy);
    if (sortDir) queryParams.append('sortDir', sortDir);
    return request
        .get(`${bookingRequests.allBuyerBookings}?${queryParams.toString()}`);
};

export const requestGetFailedTransactionsForBooking = (bookingId : String,
                                                       onSuccess?: (failedTransactions: Array<Object>) => void,
                                                       onFail?: (err: Object) => void) : (Promise<Object> | void) => {
  const result = request
    .get(bookingTransactionRequests.failedBookingTransactions(bookingId));

  if(onSuccess && onFail) {
    result
      .then((resp) => onSuccess(resp.body))
      .catch((err) => onFail(err))
  } else {
    return result
  }
}

export const requestCompleteBooking = (
    data: { id: String, buyerAccountId: String, tosDocUrl: String, paymentMethodId: String },
    onSuccess?: (booking: Object) => void,
    onFail?: (err: Object) => void
    ) : (Promise<Object> | void) => {

  const result = request
    .post(bookingRequests.completeBooking)
    .send(data);

  if(onSuccess && onFail) {
    result
      .then(resp => onSuccess(resp.body))
      .catch(err => onFail(err))
  } else {
    return result
  }
}

export const requestRetryFailedTransactionsForBooking = (bookingId: String,
                                                         onSuccess?: () => void,
                                                         onFail?: (err: Object) => void) : (Promise<Object> | void) => {
  const result = request
    .post(bookingTransactionRequests.failedBookingTransactionsRetry(bookingId));

  if(onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const requestReadSupplierPendingBooking = (id: String,
                                                  onSuccess?: () => void,
                                                  onFail?: (err: Object) => void) : Promise | void  => {
  const result = request
    .get(`${bookingRequests.supplierPendingBookings}?supplierAccountId=${id}&approvalsOnly=true`);

  if(onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const requestReadBuyerPendingBooking = (id: String,
                                                onSuccess?: () => void,
                                                onFail?: (err: Object) => void) : Promise | void => {
  const result = request
    .get(`${bookingRequests.buyerPendingBookings}?buyerAccountId=${id}`);

  if(onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}

export const updatePaymentMethod = (booking) => {
  return request
    .post(bookingRequests.updateBookingPaymentMethod)
    .send(booking);
}

export const postBookingStatusUpdate = (data, onSuccess, onFail) => {
  const { status, body} = data;
  const result = request.post(bookingRequests.updateBookingStatus[status]).send(body);

  if (onSuccess && onFail) {
    result
      .then(onSuccess)
      .catch(onFail)
  } else {
    return result
  }
}
